import { useState, useEffect } from "react";

const SMALL_SCREEN_HEIGHT = 614; // pixels

export function useSmallScreen() {
  const [isSmallScreen, setSmallScreen] = useState(
    window.innerHeight < SMALL_SCREEN_HEIGHT,
  );

  useEffect(() => {
    const handler = () => setSmallScreen(window.innerHeight < SMALL_SCREEN_HEIGHT);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return isSmallScreen;
}
